import { render, staticRenderFns } from "./psp.vue?vue&type=template&id=893fc1b6&"
import script from "./psp.vue?vue&type=script&lang=ts&"
export * from "./psp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports